import React from 'react';
import type { FC } from 'react';
import classnames from 'classnames';
import styles from './resortList.desktop.module.css';
import type { IResortList } from './Models/resort-list.model';

interface Props {
  className?: string;
  lists: IResortList[];
  linkedResortListTitle: string;
}

export const ResortListDesktop: FC<Props> = (props) => {
  const { className, lists, linkedResortListTitle } = props;

  return (
    <div className={classnames(styles.resortList, className)}>
      <h2 className={styles.title}>{linkedResortListTitle}</h2>
      <div className={styles.wrapper}>
        {lists.map((list) => {
          const { name, elements } = list;
          if (!Array.isArray(elements) || !elements.length) return null;

          return (
            <div className={styles.column} key={name}>
              <p className={styles.name}>{name}</p>
              {elements.map((elem) => (
                <a
                  className={styles.anchor}
                  href={elem.link}
                  onClick={elem.onClick}
                  key={elem.link}
                >
                  {elem.text}
                </a>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};
